import { createStore } from 'redux';
import { persistStore } from 'redux-persist';

import root from './rootReducer';

const store = createStore(root);
const persistor = persistStore(store);

export { store, persistor };
